<template>
    <div class="contact">
        <div class="contact__image-wrapper">
            <img
                v-if="image"
                class="contact__image"
                :src="image"
                :alt="title"
            />
            <div
                class="contact__image-icon"
            ></div>
        </div>
        <div class="contact__info">
            <h2 class="contact__name">
                {{title}}
            </h2>

            <p class="contact__desc">
                {{desc}}
            </p>

            <div class="contact__connections">
                <div class="contact__connection connection" v-for="(contact, id) in contacts" :key="id">
                    <p class="connection__name">{{contact.typeName}}</p>
                        <div class="connection__item-container">
                            <template v-for="(contactItem, idx) in contact.items">
                                    <div v-if="!contactItem.link" class="connection__item" :key="idx">
                                        <z-icon
                                            class="connection__icon"
                                            :name="contactItem.type"
                                            dir="top"
                                            width="24"
                                            height="24"
                                        >
                                        </z-icon>
                                        <div class="connection__value">
                                            {{contactItem.value}}
                                        </div>
                                    </div>

                                <a v-else :href="contactItem.link" class="connection__item" :key="idx">
                                    <z-icon
                                        class="connection__icon"
                                        :name="contactItem.type"
                                        dir="top"
                                        width="24"
                                        height="24"
                                    >
                                    </z-icon>
                                    <div class="connection__value">
                                        {{contactItem.value}}
                                    </div>
                                </a>
                            </template>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'contact',
    props: {
        image: {
            type: String
        },
        title: {
            type: String
        },
        desc: {
            type: String
        },

        contacts: {
            type: Array
        }
    }
}
</script>

<style lang="scss" scoped>
    .contact {
        display: flex;
        max-width: 100%;
        align-items: start;

        @include breakpoint (mobile) {
            flex-direction: column;
        }

        &__image-wrapper {
            position: relative;
            @include margin-level(right, XS);
            background-color: $token-colors-black-50;
            background: radial-gradient(125.62% 125.62% at 24.01% 12.75%, #E8E6ED 23.05%, #C3C1CA 100%, #B9B5C1 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            width: 80px;
            height: 80px;
            flex: 0 0 auto;

            @include breakpoint (mobile) {
                margin-bottom: 24px;
            }
        }

        &__image {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 4;
        }

        &__image-icon {
            background-size: cover;
            width: 24px;
            height: 24px;
            background-image: url("data:image/svg+xml,%3Csvg width='26' height='24' viewBox='0 0 26 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M18.5999 5.99997C18.5999 9.31367 15.9136 11.9999 12.5999 11.9999C9.28623 11.9999 6.59995 9.31367 6.59995 5.99997C6.59995 2.68628 9.28623 0 12.5999 0C15.9136 0 18.5999 2.68628 18.5999 5.99997ZM12.5999 23.9999H0C0 20.4035 1.19999 17.2567 4.94998 15.3087C7.64997 13.9062 9.59996 13.7999 12.5999 13.7999C15.5999 13.7999 17.5499 13.9062 20.2499 15.3087C23.9999 17.2567 25.1999 20.4035 25.1999 23.9999H12.5999Z' fill='%23B1ADC2'/%3E%3C/svg%3E%0A");
        }

        &__name {
            @include margin-level(bottom, 3XS);
            @include typo-level(XS);
            font-weight: 500;
            color: $token-colors-black;
        }

        &__desc {
            @include margin-level(bottom, XS);
            @include typo-level(2XS);
            color: $token-colors-black-60;
        }

        &__connection {
            @include margin-level(bottom, S);
        }
    }

    .connection {
        display: flex;
        align-items: start;
        flex-wrap: wrap;

        @include breakpoint (mobile) {
            flex-direction: column;
        }

        &:not(:last-child) {
            @include margin-level(right, M);
        }

        &__item-container {
            display: flex;
            flex-direction: column;
        }

        &__name {
            flex: 0 0 auto;
            @include typo-level(2XS);
            color: $token-colors-black-60;
            @include margin-level(right, 2XS);
            margin-bottom: 0;
        }

        &__item {
            display: flex;
            color: $token-colors-link-default;
            text-decoration: none;
            max-width: 100%;
            white-space: nowrap;
            overflow: hidden;
            margin-bottom: 5px;
            text-overflow: ellipsis;

            &:not(:last-child) {
                @include margin-level(right, S);
            }

            &:hover {
                color: $token-colors-link-active;
            }
        }

        &__icon {
            margin-right: 14px;

            path: {
                fill: currentColor;
            }
        }
    }
</style>
